import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

// Server functions that wrap the cities database queries
// These ensure DB operations only happen on the server

// Note: getCitiesWithCoaches function was not found in cities.db.ts
// If this function is needed, implement it in cities.db.ts first

export const getCityLabelFromValue = createServerFn({ method: "GET" })
  .validator(z.object({ citySlug: z.string() }))
  .handler(async ({ data }) => {
    const { getCityLabelFromValue: dbGetCityLabelFromValue } = await import(
      "~/lib/server/cities"
    );
    return dbGetCityLabelFromValue(data.citySlug);
  });

export const getAllCitiesGrouped = createServerFn({ method: "GET" }).handler(
  async () => {
    const { getAllCitiesGrouped: dbGetAllCitiesGrouped } = await import(
      "~/lib/server/cities"
    );
    return dbGetAllCitiesGrouped();
  },
);
